function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_673",
  "data-name": "Grupo 673",
  transform: "translate(-845 -479.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-3-Copy-7",
  d: "M.25,20.75H175a.25.25,0,0,1,0,.5H.25V24a.25.25,0,0,1-.25.25A.25.25,0,0,1-.25,24V18A.25.25,0,0,1,0,17.75.25.25,0,0,1,.25,18Z",
  transform: "translate(845.25 479.993)",
  fill: "#99999a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3-Copy-3",
  d: "M32,20.013V2.343Q32.6,0,35.686,0",
  transform: "translate(988.25 480)",
  fill: "none",
  stroke: "#99999a",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3-Copy-3-2",
  "data-name": "Path-3-Copy-3",
  d: "M32-42.013v17.671Q32.6-22,35.686-22",
  transform: "translate(988.25 544)",
  fill: "none",
  stroke: "#99999a",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  fillRule: "evenodd"
}));

var SvgGenealogyLineConector = function SvgGenealogyLineConector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179.186,
    height: 42.5,
    viewBox: "0 0 179.186 42.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenealogyLineConector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/genealogy-line-conector.8da3b575.svg";
export { ForwardRef as ReactComponent };